import { useCallback, useState } from 'react';
import constants from '../../config/constants';
import { track } from '../../external_dependencies/analytic';
import { useApplicationContext } from '../ApplicationContext';
import { useCart } from '../CartContext';

const initialData = {
  error: null,
  loading: false,
};

const useAddProductToCart = () => {
  const { appCtx } = useApplicationContext();
  const { cart } = useCart();
  const [addState, setAddState] = useState(initialData);

  const addToCart = useCallback(
    async (values, product, changeDeliveryFlow = false) => {
      setAddState((prevAddState) => ({
        ...prevAddState,
        error: null,
        loading: true,
      }));

      const isInternational = product?.availability?.internationalShipping ?? '';

      try {
        const addToCartPromise = cart.addProduct({
          appCtx,
          replaceCartItems: true,
          products: [
            {
              ...values,
              isInternational: !!isInternational,
            },
          ],
          showLightBox: false,
          changeDeliveryFlow,
        });

        const response = await addToCartPromise;
        if (response) {
          const errorCode = response?.[0].code || '';
          if (errorCode === constants.ATC_SESSION_EXPIRED_CODE) {
            throw new Error('Unauthorized');
          }
        }

        track('addToCart');
        setAddState((prevState) => ({
          ...prevState,
          error: null,
          loading: false,
        }));
      } catch (error) {
        setAddState((prevState) => ({
          ...prevState,
          error: error.message,
          loading: false,
        }));
      }
    },
    [addState]
  );

  return { addState, addToCart };
};

const useRemoveProductFromCart = () => {
  const { appCtx } = useApplicationContext();

  const { cart } = useCart();
  const [removeState, setRemoveState] = useState(initialData);

  const removeFromCart = async (products, changeDeliveryFlow = false) => {
    setRemoveState((prevRemoveState) => ({
      ...prevRemoveState,
      error: null,
      loading: true,
    }));
    try {
      const removeFromCartPromise = cart.removeProduct({
        appCtx,
        products,
        changeDeliveryFlow,
      });

      const response = await removeFromCartPromise;
      if (response) {
        const errorCode = response?.[0].code || '';
        if (errorCode === constants.ATC_SESSION_EXPIRED_CODE) {
          throw new Error('Unauthorized');
        }
      }
      setRemoveState((prevState) => ({
        ...prevState,
        error: null,
        loading: false,
      }));
    } catch (error) {
      setRemoveState((prevState) => ({
        ...prevState,
        error: error.message,
        loading: false,
      }));
    }
  };

  return { removeState, removeFromCart };
};

export { useAddProductToCart, useRemoveProductFromCart };
